var _style, _path, _path2, _polygon, _path3, _polygon2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplacementrules({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#5C6E7D;stroke-width:1.5;stroke-miterlimit:10;}\n\t.st3{fill:none;stroke:#5C6E7D;stroke-width:1.5;stroke-linecap:round;}\n\t.st4{fill:#5C6E7D;stroke:#5C6E7D;stroke-width:1.5;stroke-linecap:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.8,2C3.8,2,2,3.8,2,8.8v6.5c0,5,1.8,6.8,6.8,6.8h6.5c5,0,6.8-1.8,6.8-6.8V8.8c0-5-1.8-6.8-6.8-6.8H8.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.4,7.4c-2.1-0.8-3.8-0.9-4.9-0.9c-1.8,0-3.8,0.1-4.9,1.5c-1,1.2-0.8,2.9-0.7,3.5"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "5.1,11.5 8.4,11.5 6.8,14.2 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M6.4,17c2.1,0.8,3.8,0.9,4.9,0.9c1.8,0,3.8-0.1,4.9-1.5c1-1.2,0.8-2.9,0.7-3.5"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "18.8,12.9 15.4,12.9 17.1,10.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplacementrules);
export default __webpack_public_path__ + "static/media/replacementrules.630239d0b6674b9d44b87d08cae5a4dc.svg";
export { ForwardRef as ReactComponent };